<template>
	<div>
		<table-widget v-if="isPopularArticle"></table-widget>
		<template v-for="{widgetType, articles} in widgets">
			<text-widget v-if="isTextWidget(widgetType)" :articles="articles" :config="config"></text-widget>
			<card-widget v-else-if="isCardWidget(widgetType)" :articles="articles" :config="config"></card-widget>
			<search-widget v-else-if="isSearchWidget(widgetType)" :articles="articles" :config="config"></search-widget>
		</template>
	</div>
</template>

<script>
import axios from 'axios';
import CardWidget from './components/CardWidget.vue';
import TextWidget from './components/TextWidget.vue';
import SearchWidget from './components/SearchWidget.vue';

const POPULAR_SVC_CODE = {
	TOP: 'topRank',
	DAUM: 'daumapp',
	KAKAOTALK: 'kakaotalkTab'
}

const WIDGET_TYPE = {
	TEXT: 'TEXT',
	CARD: 'CARD',
	SEARCH: 'SEARCH'
}

export default {
	components: {
		CardWidget, TextWidget, SearchWidget
	},
	props: {
		requestConfig: Object,
		articleWidgetConfig: Object
	},
	data() {
		return {
			widgets: []
		};
	},
	computed: {
		svc() {
			return this.articleWidgetConfig.svcParam;
		},
		isPopularArticle() {
			return this.isInternalPopularArticle || this.isExternalPopularArticle;
		},
		isInternalPopularArticle() {
			return this.svc === POPULAR_SVC_CODE.TOP;
		},
		isExternalPopularArticle() {
			return this.svc === POPULAR_SVC_CODE.DAUM || this.svc === POPULAR_SVC_CODE.KAKAOTALK;
		},
		config() {
			return {
				...this.articleWidgetConfig,
				isValidCode: this.isPopularArticle,
				isExternalPopularArticle: this.isExternalPopularArticle
			}
		}
	},
	methods: {
		isTextWidget(widgetType) {
			return widgetType === WIDGET_TYPE.TEXT;
		},
		isCardWidget(widgetType) {
			return widgetType === WIDGET_TYPE.CARD;
		},
		isSearchWidget(widgetType) {
			return widgetType === WIDGET_TYPE.SEARCH;
		}
	},
	async created() {
		const {data} = await axios.get(this.requestConfig.url, {
			params: this.requestConfig.data,
			timeout: 5000,
			cache: false
		});
		this.widgets = data;
	}
}
</script>
